import { List } from 'immutable';
import { SchemeTypes } from './palettes';
import { stepGradientColors } from './interpolate';
import { autoAssignDiscreteValues, autoAssignDiscreteValuesWithMinimalRepetition } from './utils';

/**
 * @returns list of hex color strings
 */
export const getDiscreteColors = (scheme, size) => {
  const type = scheme.type;
  let colors = List();
  if (type === SchemeTypes.INTERPOLATE) {
    colors = stepGradientColors(size, scheme.points);
  } else if (type === SchemeTypes.DISCRETE || type === SchemeTypes.DISCRETE_PATTERN || type === SchemeTypes.BRAND_KIT) {
    colors = scheme.colors.map(color => color.value).toList();
  }
  return colors;
};
const mergeLeft = (map1, map2) => {
  return map1.map((value1, key) => map2.get(key) || value1).toOrderedMap();
};

/**
 * First auto assigns on all values, then override them based on the user's assignments
 * @returns assignments
 */
export const computeAssignments = (buckets, scheme, userAssignments) => {
  const colors = getDiscreteColors(scheme, buckets.size);
  const listOfBucketKey = buckets.map(bucket => bucket.key).toList();
  const unassignedColors = colors.toOrderedSet().subtract(userAssignments.toList()).toList();
  const unassignedBucketKeys = listOfBucketKey.toOrderedSet().subtract(userAssignments.keySeq()).toList();
  if (unassignedBucketKeys.size <= unassignedColors.size) {
    const assignments = autoAssignDiscreteValuesWithMinimalRepetition(listOfBucketKey, unassignedColors, userAssignments);
    return assignments;
  } else {
    const autoAssignments = autoAssignDiscreteValues(listOfBucketKey, colors);
    return mergeLeft(autoAssignments, userAssignments);
  }
};

/**
 * This auto assigns buckets to values in a scheme's property
 * @param schemeProperty - list of a property
 * @returns final assignments
 */
export const computePropertyAssignments = (buckets, schemeProperty) => {
  if (schemeProperty === undefined) {
    return undefined;
  }
  const listOfBucketKey = buckets.map(bucket => bucket.key).toList();
  const autoAssignments = autoAssignDiscreteValues(listOfBucketKey, schemeProperty);
  return autoAssignments;
};